export default "__VITE_ASSET__TVYpGIJ5__"